import { create } from 'zustand';

const useUserStore = create((set, get) => ({
  // State
  users: {},        // keyed by user id
  onlineUsers: new Set(),

  // Actions
  setUsers: (usersArray) =>
    set((state) => {
      const updated = { ...state.users };
      usersArray.forEach((user) => {
        updated[user.id] = { ...updated[user.id], ...user };
      });
      return { users: updated };
    }),

  updateUser: (id, updates) =>
    set((state) => ({
      users: {
        ...state.users,
        [id]: { ...state.users[id], ...updates },
      },
    })),

  setOnline: (userId) =>
    set((state) => {
      const next = new Set(state.onlineUsers);
      next.add(userId);
      return { onlineUsers: next };
    }),

  setOffline: (userId) =>
    set((state) => {
      const next = new Set(state.onlineUsers);
      next.delete(userId);
      return { onlineUsers: next };
    }),

  setUserStatus: (userId, status) =>
    set((state) => ({
      users: {
        ...state.users,
        [userId]: { ...state.users[userId], customStatus: status },
      },
    })),

  getUserById: (id) => get().users[id] || null,
  isOnline: (userId) => get().onlineUsers.has(userId),
}));

export default useUserStore;
